/**
 * Holds Performance data
 * @module
 */
var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var enums = require('../constants/enums');

module.exports = {
  initialize: function() {
    this.__state = {} as any;
    this.__state[enums.PerformanceData.performance_marks] = {} as any;

    this.on(actionTypes.SET_PERFORMANCE_MARKS_DATA, this.__setPerformanceMarks);
  },

 /**
  * Set performance marks data
  * @param {Object} payload
  * @param {string} payload.name
  * @param {Object} payload.data
  * @private
  */
  __setPerformanceMarks: function(payload:any) {
    if (_.isUndefined(this.__state[enums.PerformanceData.performance_marks][payload.name])) {
      this.__state[enums.PerformanceData.performance_marks][payload.name] = [];
    }
    this.__state[enums.PerformanceData.performance_marks][payload.name].push(payload.data);
    this.emitChange();
  },

  /**
   * Get Marks data
   * @return {UserTiming}
   */
  getMarks: function(): UserTiming {
    return _.mapValues(this.__state[enums.PerformanceData.performance_marks], function(marks) {
      return _.map(marks, function(mark) {
        return [mark.startTime, mark.duration];
      });
    });
  },

  /**
   * Get the sum of durations for all marks in a list of measure names
   * @param {Array.<string>} measureNames
   * @return {Object}
   */
  getDurationsFor: function(measureNames:string[]): any {
    return _.reduce(measureNames, _.bind(function(durations, measure) {
      var marks = this.__state[enums.PerformanceData.performance_marks][measure];
      if (marks) {
        durations[measure] = Math.round(_.reduce(marks, function(result, mark){
          return result + mark.duration;
        }, 0));
      }
      return durations;
    }, this), {});
  }
};
